<div class="textarea-row">
  <textarea
    #textInput
    class="chat-text-input"
    [(ngModel)]="userMessage"
    (ngModelChange)="onMessageChange($event)"
    [placeholder]="placeholder"
    [disabled]="disabled"
    name="message"
    cdkTextareaAutosize
    cdkAutosizeMinRows="1"
    cdkAutosizeMaxRows="5"
    (keydown)="onKeydown($event)"
  ></textarea>
</div>